import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-simple-list',
    templateUrl: './simple-list.component.html',
    standalone: false
})
export class SimpleListComponent implements OnInit {
  @Input() list:any;
  @Input() title = 'Data';

  constructor() { }

  ngOnInit(): void {
  }

}
